module.exports = __webpack_public_path__ + "img/undraw_conversation_re_c26v.9976cbae.svg";